import NewFacilityForOvernightRental, {StaySettingsForNewFacility} from './NewFacilityForOvernightRental'
import {
    OptionSettingForNewFacility,
    ReservationSettingsForNewFacility,
    ServerImageInformation,
} from './NewFacilityCommon'
import {Nullable} from '../../app/TypeHelpers'

export default class UpdateFacilityForOvernightRental extends NewFacilityForOvernightRental {
    private version: number

    constructor(
        sortOrder: number,
        categoryId: string | null,
        equipmentIds: number[],
        facilityName: string,
        accessControlManager: string | null,
        cardKeyFacilityNumber: string | null,
        gateNumbers: string[] | null,
        images: ServerImageInformation[],
        facilityIntroductory: string,
        optionSettings: OptionSettingForNewFacility[],
        reservationSetting: ReservationSettingsForNewFacility,
        releaseSetting: string,
        releaseStartDate: Nullable<string>,
        releaseStartTime: Nullable<string>,
        reserveBeforeCleaningTime: number,
        reserveAfterCleaningTime: number,
        staySetting: StaySettingsForNewFacility,
        version: number,
    ) {
        super(sortOrder,
            categoryId,
            equipmentIds,
            facilityName,
            accessControlManager,
            cardKeyFacilityNumber,
            gateNumbers,
            images,
            facilityIntroductory,
            optionSettings,
            reservationSetting,
            releaseSetting,
            releaseStartDate,
            releaseStartTime,
            reserveBeforeCleaningTime,
            reserveAfterCleaningTime,
            staySetting,
        )
        this.version = version
    }
}
